<template>

    <b-modal id="bv-new-email-group" size="lg" hide-footer>
      <template #modal-title>New email group</template>

      <div class="row">
        <div class="col">
            <input type="text" placeholder="" class="form-control" v-model="content">
        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
                  <div>
    <button v-if="updating" type="button" class="btn btn-success submit col">
    <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
            <button v-else type="button" class="btn btn-danger submit col" @click="sendMessage">Create</button>
      </div>
        </div>
      </div>

    </b-modal>

</template> 

<script>
export default {

  data() {
    return {
      updating: false,
      content: null,
    };
  },

  methods: {

    clearContent() {
      this.content = null;
    },

    hideNewMessageModal() {
      this.$bvModal.hide('bv-new-email-group');
    },

    sendMessage() {

        if (this.content == null || this.content == '') {this.sweetfire('Enter email group name')}

            else {

                this.$emit('set-email-group', this.content);
                this.hideNewMessageModal();

            };

        },

      

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: { title: "popup-title" },
        })

        },

    },

};
</script>

<style scoped>
.btn {border-radius:5px !important;}
input.form-control, input.form-control:focus {
  border-radius: 5px !important;
  border: none;
  box-shadow: none;
}
</style>